export default __webpack_public_path__ + "static/media/download-file.99f19c46.png";